import Anchor from "atoms/anchors/anchor";
import { siteMap } from "internal-sitemap";
import UnorderedList from "molecules/lists/unordered-list";
import React from "react";
import { t } from "utilities/localization-utils";
import { ToastManager } from "utilities/toast/toast-manager";

const useTeamOnboardingAlerts = () => {
    const showSuccessfulMigrationAlert = () => {
        ToastManager.success(t("teamCreatedSuccessfully"));
    };

    const showSuccessfulInitializationAlert = () => {
        ToastManager.success(t("teamCreatedSuccessfully"));
    };

    const showErroredInitializationAlert = () => {
        ToastManager.error(t("oopsErrorOccurred"));
    };

    const showErroredMigrationAlert = () => {
        ToastManager.error(t("manageTeamsErrorUpdatingTeam"));
    };

    const showWarningAboutEmailInvitationFailure = (
        erroredEmails: string[]
    ) => {
        ToastManager.warn(
            <>
                <div>
                    <span>
                        {t("teamInitializedSuccessButErrors")}{" "}
                        <Anchor to={siteMap.account.team}>
                            {t("teamManagement")}
                        </Anchor>
                    </span>
                </div>
                <UnorderedList listItems={erroredEmails} />
            </>
        );
    };

    const showWarningAboutMemberMigrationFailure = (
        erroredEmails: string[]
    ) => {
        ToastManager.warn(
            <>
                <div>
                    <span>
                        {t("teamInitializedSuccessButErrors")}{" "}
                        <Anchor to={siteMap.account.team}>
                            {t("teamManagement")}
                        </Anchor>
                    </span>
                </div>
                <UnorderedList listItems={erroredEmails} />
            </>
        );
    };

    const showNotEnoughSeatsAlert = () => {
        ToastManager.error(t("notEnoughSeatsForCurrentSubscription"));
    };

    const showInvalidEmailAlert = (emails: string) => {
        ToastManager.error(t("invalid-emails-field", { emails }));
    };

    const showErrorGettingTeamsAlert = () => {
        ToastManager.error(t("getTeamsError"));
    };

    const showCannotInviteTeamOwnerWarning = () => {
        ToastManager.warn(t("cannotInviteTeamOwner"));
    };

    const showCannotHaveDuplicateTeamMembers = () => {
        ToastManager.warn(t("cannotHaveDuplicateTeamMembers"));
    };

    return {
        showErrorGettingTeamsAlert,
        showErroredInitializationAlert,
        showErroredMigrationAlert,
        showInvalidEmailAlert,
        showNotEnoughSeatsAlert,
        showSuccessfulInitializationAlert,
        showSuccessfulMigrationAlert,
        showWarningAboutEmailInvitationFailure,
        showWarningAboutMemberMigrationFailure,
        showCannotInviteTeamOwnerWarning,
        showCannotHaveDuplicateTeamMembers,
    };
};

export default useTeamOnboardingAlerts;
